import React, { useState } from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Modal from 'components/modal';
import { oneLine } from 'helpers/formatters/address_formats';
import { Button } from 'components/ui/button';

import type { NewProperty, NewPropertyFromInsights, SuggestedProperty } from './types';

interface InsightsSuggestedAddressModalProps {
  property: NewProperty;
  suggestedProperties: SuggestedProperty[];
  onHide: () => void;
  onSave: (property: NewProperty | NewPropertyFromInsights) => void;
}

export default function InsightsSuggestedAddressModal({
  property,
  suggestedProperties,
  onHide,
  onSave,
}: InsightsSuggestedAddressModalProps) {
  const [selection, setSelection] = useState(0);
  const [saving, setSaving] = useState(false);
  const handleSave = async () => {
    setSaving(true);
    if (selection === -1) {
      onSave(property);
    } else {
      onSave({ insights_id: suggestedProperties[selection].propertyId });
    }
  };

  const handleSelect = (value: string) => {
    setSelection(parseInt(value));
  };

  const suggestedOptions = suggestedProperties?.map((property, i) => ({
    label: oneLine(property),
    value: i,
  }));

  return (
    <React.Fragment>
      <Modal.Header>
        Address Correction
      </Modal.Header>
      <Modal.Body>
        <ManagedFormGroup
          className="address-group"
          inline={false}
          label="Address Entered"
          name="address"
          options={[{ label: oneLine(property), value: -1 }]}
          type="radioGroup"
          value={selection}
          onValueChange={handleSelect}
        />
        {suggestedOptions && (
          <ManagedFormGroup
            className="address-group"
            inline={false}
            label="Suggested Addresses"
            name="suggested"
            options={suggestedOptions}
            type="radioGroup"
            value={selection}
            onValueChange={handleSelect}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button label="Back" variant="ghost" onClick={onHide}/>
        <Button disabled={saving} label="Create Property" onClick={handleSave}/>
      </Modal.Footer>
    </React.Fragment>
  );
}
